import { useEffect, useState, useCallback } from "react";
import { useAppStore } from "../lib/store";

export function useCountryBlocker(allowCountries: boolean | undefined) {
  const lang = useAppStore((state) => state.lang);
  const [blockedIds, setBlockedIds] = useState<Set<number> | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBlockedIds = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(`/api/country_ids/${lang}`);
        if (res.ok) {
          const data: number[] = await res.json();
          setBlockedIds(new Set(data));
        } else {
          setBlockedIds(null);
        }
      } catch {
        setBlockedIds(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBlockedIds();
  }, [lang]);

  const isLinkBlocked = useCallback(
    (articleId: number): boolean | null => {
      if (blockedIds === null) return null;
      return allowCountries === false && blockedIds.has(articleId);
    },
    [allowCountries, blockedIds],
  );

  return { isLinkBlocked, isLoading };
}
